import { render, staticRenderFns } from "./TheirWords.vue?vue&type=template&id=d6c6c67a&scoped=true&"
import script from "./TheirWords.vue?vue&type=script&lang=js&"
export * from "./TheirWords.vue?vue&type=script&lang=js&"
import style0 from "./TheirWords.vue?vue&type=style&index=0&id=d6c6c67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c6c67a",
  null
  
)

export default component.exports